﻿$.fn.dxCtrlContentEnvoiMailingAccordion = function custom_dxCtrlContentEnvoiMailingAccordion(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingaccordion dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingAccordion(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingAccordion = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxCtrlCurrent = null
    var clComDest = null
    var ds = null
    function mConstruit() {
        container.css("height", "100%")
        container.css("text-align", "left")
        mInitClComDest(function () { mRempli() })
        //var obj = option.bddCtrl.getObjet(option.data)
        //option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type }, function (data) {
        //    if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
        //    clComDest = new cComDest(option.bddCtrl, data.lst_com_destinataire)
        //    mRempli()
        //    option.jauge.mHide()
        //})

        function mRempli() {
            container.empty()
            var dxScroll = $("<div/>").appendTo(container).dxScrollView({}).dxScrollView("instance")
            ds = [{ id: 0, text: "Nom" }, { id: 1, text: "De" }, { id: 2, text: "A" }]
            if (option.type == "email") {
                ds.push({ id: 3, text: "Objet" })
                if (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base.endsWith("_aagest")) ds.push({ id: 6, text: "Rgpd" })
            }
            ds = ds.concat([{ id: 4, text: "Heure envoi" }, { id: 5, text: "Envoyer" }])

            if ((option.type == "sms" || option.type == "mobile") && !parametre.is_generique) {
                $("<div style='margin:5px'/>").appendTo(dxScroll.content()).dxCtrlWarningForm({
                    type: "error",
                    html: function () {
                        return "<div style='font-size:80%;'>" +
                            "Merci de vous assurer que les messages que vous comptez envoyer respectent la législation en cours sur le territoire français et international en prohibant, sans que cette liste soit limitative :<br/><br/>" +
                            "tout contenu à caractère raciste, antisémite, xénophobe, révisionniste, pornographique, menaçant, injurieux, violent ou portant atteinte d'une quelconque manière à l'ordre public et la dignité humaine,l'incitation à la consommation de substances interdites, l'encouragement à la violence, la réalisation de crimes et délits,tout acte délictueux, fraude et escroquerie,toute utilisation ou transmission de virus informatiques, codes ou programmes ayant pour objectif d'infecter, prendre le contrôle ou interagir avec tout téléphone, tablette, ordinateur ou logiciel.<br/><br/>" +
                            "Sont aussi interdites toutes campagnes:<br/>" +
                            " &bull; de nature politique ou religieuse<br/>" +
                            " &bull; en vue de la réalisation d'économies d'énergie ou de la production d'énergies renouvelables<br/>" +
                            " &bull; en rapport avec le CPF<br/>" +
                            "</div>"
                    }
                })
            }

            if (typeof option.selectedIds == 'undefined') option.selectedIds = [2]
            var dxAccord = $("<div/>").appendTo(dxScroll.content()).dxCtrlAccordion({
                dataSource: ds,
                selectedIds: option.selectedIds,
                itemClosed: function () { dxCtrlCurrent = null },
                multiple: false,
                itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                    itemData.titleElement = itemElement
                    itemElement.css("position", "relative")
                    mUpdateTitle(itemData)
                },
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    itemElement.empty()
                    itemElement.css("padding", "10px 5%")
                    switch (itemData.id) {
                        case 0:
                            dxCtrlCurrent = $("<div style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingNom({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                onChange: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingNom("instance")
                            break;
                        case 1:
                            dxCtrlCurrent = $("<div style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingDe({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                onChange: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingDe("instance")
                            break;
                        case 2:
                            var dxTagA = $("<div style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingA({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                clComDest: clComDest,
                                jauge: option.jauge,
                                //allowModifDest: option.allowModifDest,
                                onChange: function () {
                                    clComDest = dxTagA.option("clComDest")
                                    onChange()
                                }
                            }).dxCtrlContentEnvoiMailingA("instance")
                            dxCtrlCurrent = dxTagA
                            break;
                        case 3:
                            dxCtrlCurrent = $("<table style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingObjet({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                onChange: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingObjet("instance")
                            break
                        case 4:
                            dxCtrlCurrent = $("<table style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingDate({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                onValueChanged: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingDate("instance")
                            break;
                        case 5:
                            itemElement.css("text-align", "right")
                            itemElement.css("padding-top", "5px")
                            dxCtrlCurrent = $("<div style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingEnvoyer({
                                bddCtrl: option.bddCtrl,
                                data: option.data,
                                type: option.type,
                                clComDest: clComDest,
                                jauge: option.jauge,
                                onDemandeEnvoi: option.onDemandeEnvoi,
                                onDemandeExpediteur: function () {
                                    dxAccord.mSelect(1)
                                },
                                onDemandeDestinataire: function () {
                                    dxAccord.mSelect(2)
                                },
                                onDemandeObjet: function () {
                                    dxAccord.mSelect(3)
                                },
                                onDemandeRgpd: function () {
                                    dxAccord.mSelect(6)
                                },
                                onDemandeUpdateDest: function () {
                                    option.selectedIds = [5]
                                    mInitClComDest(function () { mRempli() })
                                },
                                onChangeAjoutStop: function () {
                                    option.onChangeAjoutStop()
                                },
                                onChange: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingEnvoyer("instance")
                            break;
                        case 6:
                            itemElement.css("text-align", "right")
                            itemElement.css("padding-top", "5px")
                            dxCtrlCurrent = $("<div style='width:100%;'/>").appendTo(itemElement).dxCtrlContentEnvoiMailingRgpd({
                                bddCtrl:option.bddCtrl,
                                data: option.data,
                                onChange: function () { onChange() }
                            }).dxCtrlContentEnvoiMailingRgpd("instance")
                            //rgpd
                            break;
                    }
                }
            }).dxCtrlAccordion("instance")
        }

    }

    function mInitClComDest(funcFin) {
        option.jauge.mShow()
        var obj = option.bddCtrl.getObjet(option.data)
        option.bddCtrl.mAjaxCall({ command: "getlstdestcomforgestion", id_table_com: obj.mGetTable().id_table, id_com: obj.cle(), type: option.type }, function (data) {
            if (typeof data.lst_com_destinataire == 'undefined') data.lst_com_destinataire = []
            clComDest = new cComDest(option.bddCtrl, data.lst_com_destinataire)
            if (typeof funcFin != 'undefined') funcFin()
            option.jauge.mHide()
        })
    }

    function onChange() {
        if (ds == null) return
        ds.forEach(function (itemData) {
            mUpdateTitle(itemData)
        })
    }

    function mUpdateTitle(itemData) {
        itemData.titleElement.empty()
        var $Table = $("<table style='width:calc(100% - 50px);table-layout:fixed;'/>").appendTo(itemData.titleElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdOk = $("<td style='width:25px;font-size:160%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:140px;white-space:nowrap;font-weight:bold;font-size:160%;padding-left:5px;' class='dx-theme-accent-as-text-color'>" + itemData.text + "</td>").appendTo($Tr)
        var $TdDetail = $("<td style='width:100%;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-family:barlow condensed;'/>").appendTo($Tr)
        switch (itemData.id) {
            case 0:
                $TdDetail.text(option.data.nom)
                break;
            case 1:
                switch (option.type) {
                    case "sms":
                        if (option.data.emetteur == null || option.data.emetteur.length == 0) {
                            $TdDetail.text(parametre.nom)
                        } else {
                            $TdDetail.text(option.data.emetteur)
                        }
                        break;
                    case "email":
                        if (option.bddCtrl.objCptCli.data.multi_societe == "1") {
                            $Td.html(itemData.text + " <span style='font-size:60%'> (& société)</span>")
                        }
                        if (option.data.nom_usuel_expediteur == null || option.data.nom_usuel_expediteur.length == 0) {
                            $("<span>(aucun nom usuel)</span>").appendTo($TdDetail)
                        } else {
                            $("<span>" + option.data.nom_usuel_expediteur + "</span>").appendTo($TdDetail)
                        }
                        $("<span> &bull; </span>").appendTo($TdDetail)
                        if (option.data.email_expediteur == null || option.data.email_expediteur.length == 0) {
                            $TdOk.html("<i class='fas fa-thumbs-down' style='color:red'></i>")
                            $("<span>(aucun email expéditeur)</span>").appendTo($TdDetail)
                        } else {
                            $("<span>" + option.data.email_expediteur + "</span>").appendTo($TdDetail)
                        }
                        break;
                }
                break;
            case 2:
                if (clComDest.mGetLstDestComNettoyer().length == 0) {
                    $TdOk.html("<i class='fas fa-thumbs-down' style='color:red'></i>")
                    $TdDetail.text("(aucun destinataire)")
                } else {
                    $TdDetail.text(clComDest.mGetLstDestComNettoyer().length + " destinataires")
                    $TdDetail.attr("title", clComDest.mGetLstDestComNettoyer().length + " destinataires")
                }
                break;
            case 3:
                if (option.data.objet == null || option.data.objet.length == 0) {
                    $TdOk.html("<i class='fas fa-thumbs-down' style='color:red'></i>")
                    $TdDetail.text("(aucun objet)")
                } else {
                    $TdOk.html("<i class='fas fa-thumbs-up' style='color:green'></i>")
                    $TdDetail.text(option.data.objet)
                    $TdDetail.attr("title", option.data.objet)
                }
                break;
            case 4:
                var cad = new cCadencementEnvoi(option.data)
                var txt = cad.mGetLibelle()
                var hasValueSaisie = true
                if (txt.length == 0) {
                    txt = "Envoi immédiat"
                    hasValueSaisie = false
                }
                $TdDetail.html(txt)
                $TdDetail.attr("title", txt)
                $TdDetail.css("color", ((hasValueSaisie) ? "orange" : ""))
                break;
            case 5:
                break;
            case 6:
                //rgpd
                option.bddCtrl.mAjaxCall({
                    command: "gethtmlurldataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    var rgpd = new cRgpd({ html: data.html, data: option.data })
                    if (!rgpd.isOkRgpd()) {
                        $TdOk.html("<i class='fas fa-thumbs-down' style='color:red'></i>")
                    } else {
                        $TdOk.html("<i class='fas fa-thumbs-up' style='color:green'></i>")
                    }
                })
                break;
        }
    }

    this.mUpdate = function () {
        onChange()
        if (dxCtrlCurrent != null && typeof dxCtrlCurrent.mUpdate != 'undefined') dxCtrlCurrent.mUpdate()
    }

    this.element = function () { return container }

    mConstruit();
}